import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { ASSETS } from "../config/assets";
import { getLegalPages, LEGAL_SLUGS } from "../data/legalPages";

function Section({ section }) {
  return (
    <section className="legal-section">
      <h2>{section.heading}</h2>
      {section.notice ? (
        <aside className="legal-notice">{section.notice}</aside>
      ) : null}
      {(section.paragraphs || []).map((text) => (
        <p key={text}>{text}</p>
      ))}
      {section.bullets?.length ? (
        <ul>
          {section.bullets.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
      {section.ordered?.length ? (
        <ol>
          {section.ordered.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ol>
      ) : null}
      {section.after ? <p>{section.after}</p> : null}
    </section>
  );
}

const LegalPage = () => {
  const location = useLocation();
  const slug = location.pathname.replace(/\/+$/, "").split("/").pop();
  const pages = getLegalPages(ASSETS.brandName);
  const page = pages[slug];

  if (!LEGAL_SLUGS.includes(slug) || !page) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="sd-page legal-page">
      <header className="sd-topbar">
        <Link to="/" className="sd-brand">
          <img
            src={ASSETS.brandLogo}
            alt={ASSETS.brandName}
            className="sd-brand-logo"
          />
        </Link>
        <nav className="sd-topbar-links">
          <Link to="/">Home</Link>
          <Link to="/login">Sign in</Link>
          <Link to="/register" className="sd-topbar-cta">
            Get started
          </Link>
        </nav>
      </header>

      <main className="sd-main legal-main">
        <p className="legal-back">
          <Link to="/">← Back to Home</Link>
        </p>

        <section className="sd-hero legal-hero">
          <p className="sd-kicker">Legal</p>
          <h1>{page.title}</h1>
          <p>Last updated: {page.lastUpdated}</p>
        </section>

        <nav className="legal-toc" aria-label="Legal documents">
          <Link
            to="/privacy-policy"
            className={slug === "privacy-policy" ? "is-active" : undefined}
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-and-conditions"
            className={slug === "terms-and-conditions" ? "is-active" : undefined}
          >
            Terms of Service
          </Link>
          <Link
            to="/refund-policy"
            className={slug === "refund-policy" ? "is-active" : undefined}
          >
            Refund Policy
          </Link>
          <Link
            to="/security"
            className={slug === "security" ? "is-active" : undefined}
          >
            Security
          </Link>
        </nav>

        <article className="legal-article">
          {page.sections.map((section) => (
            <Section key={section.heading} section={section} />
          ))}
        </article>

        <div className="sd-actions">
          <Link to="/" className="sd-btn-primary">
            Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
